var _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 42,
    viewBox: "0 0 52 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4821 11.6993C18.7064 7.82974 21.0524 6.44175 22.1974 6.23145C19.8841 10.4375 21.8469 12.5405 22.1974 13.1013C22.5479 13.6621 24.3004 15.4847 24.2303 18.7093C24.1742 21.289 22.8517 22.8219 22.1974 23.2659C22.4778 19.901 21.6366 18.7794 20.9356 18.0083C20.096 17.0848 18.2017 16.5362 18.4821 11.6993Z",
    fill: "url(#paint0_linear_2315_5169)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0902 5.25023C25.0431 2.3119 27.8522 0.833901 29.2075 0.483398C28.2261 1.5349 27.082 5.18514 27.8756 7.21304C28.5065 8.82535 29.6281 12.1902 28.5065 14.153C27.6092 15.7232 26.0297 16.8595 25.3522 17.2333C25.4918 14.2228 25.2368 13.8996 24.3005 11.9098C23.1789 9.52635 23.249 7.84394 24.0902 5.25023Z",
    fill: "url(#paint1_linear_2315_5169)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5795 9.94733C33.0748 6.80683 30.8923 4.99356 29.8642 4.47949C31.5466 8.19482 31.827 11.6297 29.8642 15.2049C28.294 18.065 29.2099 20.7428 29.8642 21.7242C30.425 18.3594 31.9414 17.378 32.7125 16.2564C33.4836 15.1348 34.2104 13.873 33.5795 9.94733Z",
    fill: "url(#paint2_linear_2315_5169)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9151 24.4306V27.691H5.07679V31.2132H10.1936V34.3784H5.07679V41.1372H0.988159V24.4306H11.9151Z",
    fill: "url(#paint3_linear_2315_5169)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3706 32.7601C13.3706 31.1101 13.7293 29.6425 14.4466 28.3574C15.1639 27.0564 16.1601 26.0489 17.4353 25.335C18.7265 24.6051 20.185 24.2402 21.8109 24.2402C23.8034 24.2402 25.509 24.7638 26.9276 25.8109C28.3463 26.8581 29.2947 28.286 29.7729 30.0947H25.2778C24.9431 29.3966 24.4649 28.8651 23.8432 28.5002C23.2375 28.1353 22.5441 27.9528 21.7631 27.9528C20.5038 27.9528 19.4836 28.3891 18.7026 29.2617C17.9215 30.1343 17.531 31.3005 17.531 32.7601C17.531 34.2198 17.9215 35.3859 18.7026 36.2585C19.4836 37.1311 20.5038 37.5674 21.7631 37.5674C22.5441 37.5674 23.2375 37.385 23.8432 37.02C24.4649 36.6551 24.9431 36.1236 25.2778 35.4255H29.7729C29.2947 37.2342 28.3463 38.6621 26.9276 39.7093C25.509 40.7406 23.8034 41.2562 21.8109 41.2562C20.185 41.2562 18.7265 40.8992 17.4353 40.1853C16.1601 39.4554 15.1639 38.448 14.4466 37.1628C13.7293 35.8777 13.3706 34.4101 13.3706 32.7601Z",
    fill: "url(#paint4_linear_2315_5169)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.2853 24.4306V41.1372H47.1967V31.118L43.4428 41.1372H40.1432L36.3654 31.0942V41.1372H32.2768V24.4306H37.1066L41.8169 35.9967L46.4794 24.4306H51.2853Z",
    fill: "url(#paint5_linear_2315_5169)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2315_5169",
    x1: 21.332,
    y1: 6.23145,
    x2: 21.332,
    y2: 23.2659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2315_5169",
    x1: 26.3218,
    y1: 0.483398,
    x2: 26.3218,
    y2: 17.2333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2315_5169",
    x1: 31.399,
    y1: 4.47949,
    x2: 31.399,
    y2: 21.7242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31D0FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2315_5169",
    x1: -0.49427,
    y1: 26.2965,
    x2: 52.7166,
    y2: 39.4278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#174EE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2315_5169",
    x1: -0.49427,
    y1: 26.2965,
    x2: 52.7166,
    y2: 39.4278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#174EE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DEFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2315_5169",
    x1: -0.49427,
    y1: 26.2965,
    x2: 52.7166,
    y2: 39.4278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#174EE7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00DEFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo1);
export default __webpack_public_path__ + "static/media/logo-1.e3680b64ff87336c2444db4bc351db87.svg";
export { ForwardRef as ReactComponent };